import React from "react";

interface SeverityPillProps {
    severity: string;
}

export const SeverityPill: React.FC<SeverityPillProps> = ({ severity }) => {
    let label = severity;
    if (severity === "high") label = "High";
    if (severity === "medium") label = "Medium";
    if (severity === "low") label = "Low";

    const baseClass =
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium";

    let colorClass =
        "bg-slate-800 text-slate-200 border border-slate-600";

    if (severity === "high") {
        colorClass =
            "bg-rose-900/60 text-rose-100 border border-rose-500/70";
    } else if (severity === "medium") {
        colorClass =
            "bg-amber-900/60 text-amber-100 border border-amber-500/70";
    } else if (severity === "low") {
        colorClass =
            "bg-emerald-900/60 text-emerald-100 border border-emerald-500/70";
    }

    return (
        <span className={`${baseClass} ${colorClass}`}>
            {label.charAt(0).toUpperCase() + label.slice(1)}
        </span>
    );
};
